<template>
    <esp-page height="100%">
<!--        <esp-page-header gap="20px" btn-width="400px">-->
<!--            <el-row>-->
<!--                <esp-search-item labelWidth="100px" inputWidth="calc(100% - 100px)" labelName="计费周期：" :span="5">-->
<!--                  <el-select v-model="tabParam.searchParam.intervalUnit" @change="tableReLocad()" style="width: 100%;">-->
<!--                    <el-option label="全部" value=""></el-option>-->
<!--                    <el-option label="月" value="MONTH"></el-option>-->
<!--                    <el-option label="年" value="YEAR"></el-option>-->
<!--                  </el-select>-->
<!--                </esp-search-item>-->
<!--                <esp-search-item labelWidth="100px" inputWidth="calc(100% - 100px)" labelName="状态：" :span="5">-->
<!--                  <el-select v-model="tabParam.searchParam.status" @change="tableReLocad()" style="width: 100%;">-->
<!--                    <el-option label="全部" value=""></el-option>-->
<!--                    <el-option label="激活" value="ACTIVE"></el-option>-->
<!--                    <el-option label="无效" value="INACTIVE"></el-option>-->
<!--                    <el-option label="已取消" value="CANCELED"></el-option>-->
<!--                  </el-select>-->
<!--                </esp-search-item>-->
<!--            </el-row>-->
<!--            <template slot="btn">-->
<!--                <el-row style="width: 100%">-->
<!--                    <el-col :span="24">-->
<!--                        <el-button type="primary" size="mini" @click="tableReLocad()">查询</el-button>-->
<!--                    </el-col>-->
<!--                </el-row>-->
<!--            </template>-->
<!--        </esp-page-header>-->

        <esp-page-main style="margin-top: 5px;" height="calc(100% - 130px)">
            <el-table :data="tableData.data"
                      size="mini"
                      border
                      highlight-current-row
                      v-loading="tabParam.showloding"
                      @sort-change="sortChange"
                      @selection-change="checkEdList = $event"
                      row-key="pk"
                      @row-dblclick="viewForm"
                      height="100%">
                <el-table-column :label="this.$t('member_subscription_record_serial_number')" width="110px">
                    <template slot-scope="scope">{{scope.$index + 1}}</template>
                </el-table-column>
              <el-table-column :label="this.$t('member_subscription_record_member_type')" prop="intervalUnit">
                <template slot-scope="scope">
                  <div v-if="scope.row.intervalUnit == 'MONTH'">{{$t("member_subscription_record_member_type_month")}}</div>
                  <div v-else-if="scope.row.intervalUnit == 'YEAR'">{{$t("member_subscription_record_member_type_year")}}</div>
                  <div v-else-if="scope.row.intervalUnit == 'DAY'">{{$t("member_subscription_record_member_type_day")}}</div>
                  <div v-else></div>
                </template>
              </el-table-column>
                <el-table-column :label="this.$t('member_subscription_record_subscription_id')" prop="id"></el-table-column>
                <el-table-column :label="this.$t('member_subscription_record_status')" sort-by="status" prop="status">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status == 'ACTIVE'">{{$t("member_subscription_record_status_active")}}</div>
                    <div v-else-if="scope.row.status == 'INACTIVE'">{{$t("member_subscription_record_status_inactive")}}</div>
                    <div v-else-if="scope.row.status == 'CANCELED'">{{$t("member_subscription_record_status_canceled")}}</div>
                    <div v-else></div>
                  </template>
                </el-table-column>

                <el-table-column :label="this.$t('member_subscription_record_currency')" prop="currencyCode"></el-table-column>
                <el-table-column :label="this.$t('member_subscription_record_amount')" prop="mny">
                  <template slot-scope="scope">{{ fun(scope.row.mny) }} </template>
                </el-table-column>
                <el-table-column :label="this.$t('member_subscription_record_start_time')" prop="startDate" width="150px">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.startDate) }}
                  </template>
                </el-table-column>
                <el-table-column :label="this.$t('member_subscription_record_end_time')" prop="endDate" width="150px">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.endDate) }}
                  </template>
                </el-table-column>
                <el-table-column :label="this.$t('member_subscription_record_operate')">
                    <template slot-scope="scope">
<!--                      <el-tooltip effect="light" :content="$t('member_subscription_record_operate_view')" placement="top-start" size="mini">-->
<!--                          <el-button @click="viewForm(scope.row)" type="info" icon="el-icon-view" circle size="mini"/>-->
<!--                      </el-tooltip>-->

                    <el-tooltip effect="light" :content="$t('member_subscription_record_operate_cancel')" placement="top-start" size="mini">
                      <el-button @click="cancelForm(scope.row)" type="info" icon="el-icon-remove" circle size="mini"/>
                    </el-tooltip>
                  </template>
                </el-table-column>
            </el-table>
        </esp-page-main>
        <esp-page-footer style="margin-top: 5px;">
            <template slot="right">
                <el-pagination style="margin-top: 5px"
                   @size-change="tableSizeChange"
                   @current-change="tableReLocad"
                   :current-page="tabParam.pageNum"
                   :page-sizes="tabParam.pageSizeGroup"
                   :page-size="tabParam.pageSize"
                   background
                   size="mini"
                   :small="true"
                   layout="total,  prev, pager, next,sizes,jumper"
                   :total="tableData.totalRow">
                </el-pagination>
            </template>
        </esp-page-footer>

        <view-dialog ref="viewDialog"></view-dialog>


      <el-dialog
        :title="this.$t('member_cancel_subscription_dialog_title')"
        :visible.sync="cancelDialogVisible" width="30%" center class="language-dialog">
        <div>
          <div class="logout-dialog-title">
            <span>{{this.$t('member_cancel_subscription')}}</span>
          </div>
          <div class="reason-input-container">
            <span class="reason-label">{{this.$t('member_reason')}}</span>
            <el-input
              type="textarea"
              :rows="2"
              v-model="formData.reason"
              :placeholder="this.$t('member_need_reason')"
              @keyup.enter="confirmCancel"
              ref="cancelReasonInput"
              class="reason-textarea"
            ></el-input>
          </div>
          <div class="logout-dialog-buttons">
            <button class="dialog-btn cancel-btn" @click="cancelDialogVisible = false">
              {{this.$t("layout_cancel")}}
            </button>
            <button class="dialog-btn confirm-btn" @click="confirmCancel()">
              {{this.$t("layout_confirm")}}
            </button>
          </div>
        </div>
      </el-dialog>
    </esp-page>


</template>

<script>
    import * as cache from '@/utils/cache';
    import * as curApi from "@/api/tcode/subscriptions";
    import ViewDialog from "./view";

    export default {
        name: "TcodeSubscriptionsIndex",
        components: {ViewDialog},
        data() {
            return {
                checkEdList: [],                            // 选中的行
                tableData: {
                    totalRow: 0,                               // 总行数
                    data: []                                   // 表格中的数据
                },
                tabParam: {
                  showloding: false,                         // 是否显示加载框
                  pageSizeGroup: this.espConstant.esp_page_size_group,    // 每页数量
                  pageNum: 1,                                // 当前页码
                  pageSize: this.espConstant.esp_page_size,  // 分页，-1  不分页
                  sortCol: "endDate",
                  sortType: 2,                             // 排序方式
                      searchParam: {
                          key: "",
                          isSeal: "",
                          pk_user: "",
                      },
                },
                formData: {
                  id:"",
                  reason:"",
                },
              cancelDialogVisible: false,
              currentRow: null  // 保存当前操作的行数据
            }
        },
        methods: {

            /**
             * 重置条件
             */
            reSetParam: function () {
                this.tabParam.searchParam = {};
                this.tableReLocad();
            },
            formatDate(dateString) {
              if (!dateString) return '';
              return dateString.split(' ')[0]; // 直接分割取日期部分
            },
            /***
             * 查看
             */
            viewForm: function (row) {
                if (row && row.pk) {
                    this.$refs.viewDialog.init(row.pk);
                }
            },
            /**
             * 取消订阅
             */
            cancelForm: function (row) {
              if (row && row.pk) {
                this.formData.id = row.id;
                this.cancelDialogVisible = true;
              }
            },
            confirmCancel: function () {
              if (this.formData.reason.trim() === '') {
                this.$message({type: "error", message: this.$t('member_need_reason')});
                return;
              }
              const loading = this.$loading(this.espConstant.loadingType);
              curApi.cancelSubscription(this.formData).then(resp => {
                  loading.close();
                  this.$message({type: "success", message: this.$t('layout_operate_sucess'), duration: 1500});
                  this.tableReLocad();
              }).catch(error => {
                  loading.close();
              })
              this.cancelDialogVisible = false;
              this.tableReLocad();
            },
            /**
             * 数据加载
             */
            tableReLocad: function (pageNum) {
                if (pageNum) {
                    this.tabParam.pageNum = pageNum;
                } else {
                    this.tabParam.pageNum = 1;
                }
                this.tabParam.showloding = true;
                const pk_user = cache.getUserInfo().pk;
                this.tabParam.searchParam.pk_user = pk_user;
                curApi.list(this.tabParam).then(resp => {
                    if (resp.data) {
                        this.tableData = resp;
                    } else {
                        this.tableData = {
                            totalRow: 0,
                            data: []
                        }
                    }
                    this.tabParam.showloding = false;
                }).catch(error => {
                    this.tabParam.showloding = false;
                })
            },
            //排序事件
            sortChange: function (col) {
                if (col.prop) {
                    this.tabParam.sortCol = col.prop;
                    if (col.order == "descending") {
                        this.tabParam.sortType = 2;
                    } else {
                        this.tabParam.sortType = 1;
                    }
                    this.tableReLocad();
                }
            },
            //页码变化事件
            tableSizeChange: function (val) {
                this.tabParam.pageSize = val;
                this.tableReLocad();
            },
            fun(data){
              if (data == null || data == undefined || data == "" || data == 0) {
                return '0.00';
              }
              if (typeof (data) === 'number') {
                return (data).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
              }
              return data;
            },
          confirmLogout: function() {
            this.cancelDialogVisible = false;
          },
        },
        /**
         * 渲染前
         */
        created: function () {
            this.tableReLocad();
        },
    }
</script>

<style>
.reason-input-container {
  display: flex;
  align-items: flex-start; /* 顶部对齐 */
  margin: 20px 0;
  padding-left: 20px;
  padding-right: 20px;
}

.reason-label {
  width: 60px;
  padding-top: 8px; /* 与输入框对齐 */
  font-size: 14px;
}

.reason-textarea {
  flex: 1;
  margin-left: 10px;
}

/* 保持原有样式 */
.logout-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.logout-dialog-title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}

.logout-dialog-buttons {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 30px;
}

.dialog-btn {
  padding: 8px 35px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn {
  background-color: #F4F3F1;
  color: #AA81FF;
  border: 1px solid #AA81FF;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}

.confirm-btn {
  background-color: #AA81FF;
  color: white;
  border: none;
}

.confirm-btn:hover {
  background-color: #7200D6;
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/subscriptions/index.vue